export default __webpack_public_path__ + "static/threatGPT-5c913792d0292bbf62e80acd94ba6e84.png";